import { AlertService } from 'src/app/shared/store/alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { ImportsActions } from './imports.actions';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';
import { ImportService } from '../services/import.service';
import { ImportCauForm } from '../models/imports-cau-form.model';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';
import { StartCourseCyLRequest } from '../models/start-course-cyl-request.model';

export class ImportsStateModel {
  importsCauFileForm: {
    model: ImportCauForm;
  };
  public isLoadingImports: boolean;
  public error: string;
}

const defaults = {
  importsCauFileForm: {
    model: null,
  },
  isLoadingImports: false,
  error: null,
};

@State<ImportsStateModel>({
  name: 'imports',
  defaults,
})
@Injectable()
export class ImportsState {
  constructor(
    private importService: ImportService,
    private alertService: AlertService,
    private localizationService: LocalizationService,
    public store: Store
  ) {}


  @Action(ImportsActions.StartCourseCyL)
  importCau(ctx: StateContext<ImportsStateModel>, { user}: ImportsActions.StartCourseCyL) {
    var state = ctx.getState();
    let importCauForm = state.importsCauFileForm.model;

    this.alertService.confirm(
      this.getTitle(),
      this.localizationService.translate('imports.importsCauConfirm'),
      this.localizationService.translate('buttons.accept'),
      this.localizationService.translate('buttons.cancel'),
      this.localizationService.translate('imports.importsCauConfirm')
      .replace('{0}', importCauForm.exerciseId.toString() )
    ).then((result) => {
      if (result.value) {
        ctx.patchState({ isLoadingImports: true });
        var startCourseCyLRequest = new StartCourseCyLRequest(importCauForm.contentFile);
        return this.importService.startCourseCyL(startCourseCyLRequest, importCauForm.exerciseId, user)
          .subscribe({
            next: () => ctx.dispatch(new ImportsActions.StartCourseCyLSuccess()),
            error: (error) => ctx.dispatch(new ImportsActions.Error(error)),
          });
      } else {
        return null;
      }
    });
  }

  @Action(ImportsActions.StartCourseCyLSuccess)
  importCauSuccess(ctx: StateContext<ImportsStateModel>, {}: ImportsActions.StartCourseCyLSuccess) {
    var state = ctx.getState();
    ctx.patchState({
      ...state,
      isLoadingImports: false,
    });
  }

  @Action(ImportsActions.Error)
  onErrorOcurred(
    ctx: StateContext<ImportsStateModel>,
    { error }: ImportsActions.Error
  ) {
      ctx.patchState({
        error: error,
        isLoadingImports: false,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  @Action(ImportsActions.SetImportsDefaultState)
  setImportsDefaultState(
    ctx: StateContext<ImportsStateModel>,
    {}: ImportsActions.SetImportsDefaultState
  ) {
    ctx.setState(
      patch({
        importsCauFileForm: patch({
          model: defaults.importsCauFileForm.model,
        }),
      })
    );
  }

  @Action(ImportsActions.SetDefaultState)
  setDefaultState(ctx: StateContext<ImportsStateModel>, {}: ImportsActions.SetDefaultState
  ) {
    ctx.patchState(defaults);
  }

  private getTitle() {
    return this.localizationService.translate('imports.import-cau-file');
  }
}
